import React, { useCallback, useState, Fragment, useEffect } from 'react';
import { useAuth } from '../../../../Context/Auth/AuthContext';
import { toast } from 'react-toastify';
import PSO from '../../../../services/PSO';
import Strings from '../../../../translations/Translations';
import VideoSong from '../../../video/components/VideoSong';

export default function EditSong(props) {
  const { currentIt } = props;
  const { authenticated, toggleLoading } = useAuth();

  const [song, setSong] = useState();
  const [songType, setSongType] = useState();

  const [allDataRemixPars, setAllDataRexmiPars] = useState();

  const updateSong = useCallback(async () => {
    if (song && songType && currentIt && currentIt.rid) {

      if (songType === 1) {
        // Checking if new song is different from current song
        if (allDataRemixPars && allDataRemixPars.getRemixApprovedElements && allDataRemixPars.getRemixApprovedElements.its_songs && allDataRemixPars.getRemixApprovedElements.its_songs.length > 0 && allDataRemixPars.getRemixApprovedElements.its_songs[0].esongsid && parseInt(allDataRemixPars.getRemixApprovedElements.its_songs[0].esongsid) !== parseInt(song.obj.id)) {
          // PepBlast song
          toggleLoading(true);
          try {
            const response = await PSO.replaceOldestExistingElementInRemix({
              un: authenticated.un,
              al: authenticated.al,
              rid: currentIt.rid,
              etype: 3,
              e_sid: song.obj.id
            });

            if (response.result === 'success') {
              toast.success(Strings('video_updated'));
            } else {
              const message = (response && response.error) ? response.error : Strings('error_on_request');
              toast.error(message);
            }
          } catch (err) {
            console.error(err);
          }
          toggleLoading(false);
        } else {
          toast.info(Strings('song_already_selected'));
        }
      } else if (songType === 2) {
        // Checking if new song is different from current song
        if (allDataRemixPars && allDataRemixPars.its && allDataRemixPars.its.length > 0 && allDataRemixPars.its[0].apmsoid && allDataRemixPars.its[0].apmsoid && parseInt(allDataRemixPars.its[0].apmsoid) !== parseInt(song.obj.id)) {
          // Apple Music
          if (song && song.obj && song.obj.id) {
            const appleMusicId = song.obj.id;
            let appleMusicParams;

            // Getting Apple Music parameters
            toggleLoading(true, Strings('getting_music_details'));

            try {
              const response = await PSO.appleMusicSearchID(appleMusicId);

              if (response.data && response.data.length > 0) {
                const targetMusic = response.data[0];

                appleMusicParams = {};
                appleMusicParams.mvon = 1; // Music Video ON
                appleMusicParams.apmon = 1; // Apple Music Video ON
                appleMusicParams.apmsoid = appleMusicId; // Apple Music Song ID
                appleMusicParams.apmna = encodeURIComponent(targetMusic.attributes.name); // Apple Music Name
                appleMusicParams.apmgen = encodeURIComponent(targetMusic.attributes.genreNames[0]); // Apple Music Genre
                appleMusicParams.apmart = encodeURIComponent(targetMusic.attributes.artistName); // Apple Music Artist
                appleMusicParams.apmpageurl = targetMusic.attributes.url;

                // Apple Music Album ID
                if (targetMusic && targetMusic.relationships && targetMusic.relationships.albums && targetMusic.relationships.albums.data && targetMusic.relationships.albums.data[0] && targetMusic.relationships.albums.data[0].id) {
                  appleMusicParams.apmartid = targetMusic.relationships.albums.data[0].id;
                }

                // Apple Music Artist ID
                if (targetMusic && targetMusic.relationships && targetMusic.relationships.artists && targetMusic.relationships.artists.data && targetMusic.relationships.artists.data[0] && targetMusic.relationships.artists.data[0].id) {
                  appleMusicParams.apmalbid = targetMusic.relationships.artists.data[0].id;
                }

                let artwork = targetMusic.attributes.artwork.url;
                artwork = artwork.replace('{w}', '800');
                artwork = artwork.replace('{h}', '800');
                let preview = targetMusic.attributes.previews[0].url;

                appleMusicParams.apmthmurl = artwork; // Apple Music Thumb URL
                appleMusicParams.apmpsourl = preview; // Apple Music Song URL
              }
            } catch (err) {
              console.error(err);
            }

            try {
              const response = await PSO.modifyRemix({
                un: authenticated.un,
                al: authenticated.al,
                rid: currentIt.rid,
                args: appleMusicParams
              });
      
              if (response.result === 'success') {
                toast.success(Strings('video_updated'));
              } else {
                const message = (response && response.error) ? response.error : Strings('error_on_request');
                toast.error(message);
              }
            } catch (err) {
              console.error(err);
            }
            toggleLoading(false);
          }
        } else {
          toast.info(Strings('song_already_selected'));
        }
      }
    }
  }, [authenticated, currentIt, song, songType, toggleLoading, allDataRemixPars]);

  const getAllRemixPars = useCallback(async() => {
    toggleLoading(true);
    try {
      const response = await PSO.getRemixPars({
        un: authenticated.un,
        al: authenticated.al,
        rid: currentIt.rid,
        getappelements: 1
      });

      if (response.result === 'success' && response.getRemixApprovedElements && response.getRemixApprovedElements.its_styles && response.getRemixApprovedElements.its_styles.length > 0) {
        setAllDataRexmiPars(response);
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        console.error(message);
      }
    } catch (err) {
      console.error(Strings('general_error'));
    }
    toggleLoading(false);
  }, [authenticated, toggleLoading, currentIt, setAllDataRexmiPars]);

  useEffect(() => {
    getAllRemixPars();
  }, [getAllRemixPars]);

  return (
    <Fragment>
      <VideoSong
        parentSetSong={setSong}
        parentSetSongType={setSongType}
        parentSongType={songType}
        parentSong={song}
        showSaveButton={true}
        saveButtonCallback={updateSong}
        disableOriginalSong={true}
      />
    </Fragment>
  );
}
